import { formatCurrencyToShow } from "./currency";
import { percentageMask } from "./masks/number";

export const formatTransactionFee = (
    feePercent?: string,
    fixedFee?: string
): string => {
    const parts: string[] = [];

    if (feePercent && Number(feePercent) > 0) {
        parts.push(percentageMask(feePercent, true));
    }

    if (fixedFee && Number(fixedFee) > 0) {
        parts.push(`R$${formatCurrencyToShow(fixedFee)}`);
    }

    return parts.join(" + ") || "";
};
